//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import User from '@/components/User.vue';

export default {
  components: { User },
  props: {
    value: { type: Boolean, default: false },
    messages: { type: Array, required: true },
    influenceList: { type: Array, required: true },
  },
  data() {
    return {
      editing: {
        modal: false,
        loader: false,
        data: {
          feedbackId: null,
          id: null,
          comment: '',
          influence: '',
        },
      },
    };
  },
  computed: {
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    openEditModal(message) {
      this.editing.data = {
        feedbackId: message.id,
        comment: message.comment,
        influence: message.influence,
      };
      this.editing.modal = true;
    },
    async applyEdit() {
      this.editing.loader = true;
      await this.$emit('edit', { ...this.editing.data });
      this.editing.loader = false;
      this.editing.modal = false;
    },
  },
};
